import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { SkeletonTitle, ItemWrapper, SkeletonItem } from './DiscoverInsightList.styles.js';

const DiscoverInsightListSkeleton = () => (jsxs(Fragment, { children: [jsx(SkeletonTitle, { "data-testid": "insight-list-skeleton" }), jsxs(ItemWrapper, { children: [jsx(SkeletonItem, {}), jsx(SkeletonItem, {})] })] }));

export { DiscoverInsightListSkeleton };
